module.exports = __webpack_public_path__ + "static/media/thaihouse_thumb_even.b28c1abf.jpg";